import { createSlice } from "@reduxjs/toolkit"

const slice = createSlice({
    name: 'supplyOrder',
    initialState: {
        supplyOrder: '',
        supplyOrders: {
            list: [],
            offset: 0,
            limit: 10,
            count: 0,
            query: '',
            filters: {
                status: 'newAndWork',
                // departmentId: ''
                departmentId: null,
                agreeDirector: '',
            }
        },
    },
    reducers: {
        setSupplyOrder(state, action) {
            state.supplyOrder = action.payload
        },
        setSupplyOrdersList(state, action) {
            state.supplyOrders.list = action.payload
        },
        setSupplyOrdersOffset(state, action) {
            state.supplyOrders.offset = action.payload
        },
        setSupplyOrdersLimit(state, action) {
            state.supplyOrders.limit = action.payload
        },
        setSupplyOrdersCount(state, action) {
            state.supplyOrders.count = action.payload
        },
        setSupplyOrdersQuery(state, action) {
            state.supplyOrders.query = action.payload
        },
        setSupplyOrdersFiltersStatus(state, action) {
            state.supplyOrders.filters.status = action.payload
        },
        setSupplyOrdersFiltersDepartmentId(state, action) {
            state.supplyOrders.filters.departmentId = action.payload
        },
        setSupplyOrdersFiltersAgreeDirector(state, action) {
            state.supplyOrders.filters.agreeDirector = action.payload
        },
        addSupplyOrder(state, action) {
            state.supplyOrders.list.unshift(action.payload)
        },
        addSupplyOrderUser(state, action) {
            if (state.supplyOrder) {
                state.supplyOrder['user'] = action.payload
            }
            // state.supplyOrder.list.unshift(action.payload)
        },
        editSupplyOrderItems(state, action) {
            if (state.supplyOrder) {
                state.supplyOrder['items'] = action.payload
            }
            // state.supplyOrder.list.unshift(action.payload)
        },
        editSupplyOrderItem(state, action) {
            if (state.supplyOrder && state.supplyOrder.items) {
                state.supplyOrder['items'] = state.supplyOrder['items'].map(item => {
                    if (item.id === action.payload.id) {
                        return action.payload
                    } else {
                        return item
                    }
                })
            }
        },
        setSupplyOrderBills(state, action) {
            if (state.supplyOrder) {
                state.supplyOrder['bills'] = action.payload
            }
            // state.supplyOrder.list.unshift(action.payload)
        },
    }
})

export default slice.reducer

export const {
    setSupplyOrder,
    setSupplyOrdersList,
    setSupplyOrdersOffset,
    setSupplyOrdersLimit,
    setSupplyOrdersCount,
    setSupplyOrdersQuery,
    setSupplyOrdersFiltersStatus,
    setSupplyOrdersFiltersDepartmentId,
    setSupplyOrdersFiltersAgreeDirector,
    addSupplyOrder,
    addSupplyOrderUser,
    editSupplyOrderItems,
    editSupplyOrderItem,
    setSupplyOrderBills,
} = slice.actions